// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"3b9a3ca5","125":"288df466","911":"a8ee3fac"}[chunkId] + ".chunk.js";
};